export default "__VITE_ASSET__BToxpz_d__"